import { post, get, getJson,getResponseType } from '@/api/http';

/**
 *
 * 获取历史聊天记录(已审核)
 * @export
 * @param {*} data
 * @returns
 */

export const getChatHistoryList = (params, token) =>
  getJson(`${config.cpp}monitor/v1/chat/public/list`, params, { token });
/**
 *
 * 获取历史聊天记录(未审核)
 * @export
 * @param {*} data
 * @returns
 */
export function getChatHistoryAuditList(params,token) {
  return getJson(`${config.cpp}monitor/v1/chat/public/audit/list`, params,{token});
}

/**
 *
 * 根据id获取聊天信息
 * @export
 * @param {*} data
 * @returns
 */

export function getByIdsToChat(data) {
  return post(`${config.cpp}monitor/v1/chat/public/listByIds`, data);
}

/**
 *
 * 根据uid获取用户信息
 * @export
 * @param {*} data
 * @returns
 */
export function getUserInfoToUid(uid) {
  return get(`${config.cpp}monitor/v1/webcast/user/uid/${uid}`);
}

/**
 *
 * 获取点赞数量
 * @export
 * @param {*} data
 * @returns
 */
// export const getWebcastCount = (data) => {
//   return post(`${config.cpp}handler/v2/praise/webcast/count`, data);
// };
/**
 *
 * 获取场次点赞数量
 * @export
 * @param {*} data
 * @returns
 */

export const getWebcastCount = (data,token) => {
  return post(`${config.cpp}handler/v2/praise/count`, data,{token});
};

/**
 *
 * 下载聊天
 * @export
 * @param {*} data
 * @returns
 */

export const downloadChat = (liveId,params)=>{
  return getResponseType(`${config.cpp}monitor/v1/chat/downloadExcel/${liveId}`, 'arraybuffer',params);
}